import React,{useState} from 'react'

const Join = ({socket,setInRoom ,name,setName,roomId,setRoomId,setFriend,setPlayers,setGridSize}) => {

    const JoinHandle = () => {
      if (name.trim() && roomId.trim()) {
        // Emit the 'join_room' event with the room ID and name
        socket.emit('join_room', { roomId, name });

        socket.on('room_joined', (data) => {
          setFriend(data.roommate);
          setPlayers([data.roommate,name]);
          setGridSize(data.gridSize);
          console.log(data.gridSize);
          setInRoom(true);
          const msgData = {
            room: roomId,
            type: "text",
            message:["dot",[data.roommate,name]],
            userId: name,
          };
          // Emit the message to the server
          socket.emit("send_msg", msgData);
        });
        socket.on('error_message', (message) => {
          alert(message);
        });

      } else {
        alert('Please enter both room ID and your name.');
      }    
    };

  return (
    <div className='flex flex-col w-full h-full rounded-b-md'>
    <h3 className='text-center text-theme-3 text-xl font-mono font-bold mb-6'>Online Play</h3>
    <input type='text' className=' bg-slate-100 placeholder-slate-600 m-1 h-10 pl-2 mb-2' placeholder='Enter room id:' value={roomId} onChange={(e)=>{setRoomId(e.target.value)}} />
    <input type='text' className='bg-slate-100 placeholder-slate-600 m-1 h-10 pl-2 mb-2' placeholder='Enter your name:' value={name} onChange={(e)=>{setName(e.target.value)}} />
    <button onClick={JoinHandle} className=' h-10 text-theme-4 font-bold hover:text-theme-3 bg-theme-2 m-1 px-2 text-lg py-1'>Join Room</button>
    {/* <div></div> */}
    </div>
  )
}

export default Join